import parseAmount from 'helpers/utils/parseAmount';
import formatDate from 'helpers/utils/formatDate';
import { t } from '@config/i18n';
import { Receipt } from './data/useGetPartnerTransactions';
import ActionButtons from './modules/ActionButtons';

export const DEFAULT_ROWS_PER_PAGE = 25;
export const DEFAULT_PAGE = 1;
export interface TransferReceiptParams {
  fromDate: string;
  toDate: string;
  page: string;
  limit: string;
  currentPage: string;
}

/**
 *  Transfer Receipt list columns for the table
 */
export const columns = [
  {
    title: 'COMMON:CREATED_AT',
    content: (row: Receipt) => `${formatDate(row?.createdAt)}`,
  },
  {
    title: 'COMMON:AMOUNT',
    content: (row: Receipt) => `${parseAmount(row?.amount)}`,
  },
  {
    title: 'MOVEMENTS:TRANSACTION_TYPE',
    content: (row: Receipt) =>
      `${t(`TRANSFER_RECEIPT:TRANSACTION_TYPES.${row?.customerTransactionType}`)}`,
  },
  {
    title: 'COMMON:VOUCHER',
    content: (row: Receipt) => <ActionButtons {...{ row }} />,
  },
];
